import { computed } from 'vue';
import { useAuthenticated } from '@othercommerce/foundation';
import { Features } from '@shared/features';

export function useOffersPermissions() {
  const authenticated = useAuthenticated();

  const canRequestOffers = computed(() => {
    if (Features.offers.isDisabled) {
      return false;
    }

    if (Features.streamsoft.isEnabled) {
      if (!authenticated.value) {
        return false;
      }

      if (!authenticated.value.erpId) {
        return false;
      }

      if (!authenticated.value.b2b) {
        return false;
      }
    }

    return true;
  });

  return { canRequestOffers };
}
